import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import { DashboardEntryPanasonicInfoModal } from "./DashboardEntryPanasonicInfoModal/DashboardEntryPanasonicInfoModal";
import "./DashboardEntryPanasonicProjectInfoWidget.scss";
import UIService from "../../../services/UIService";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";

type Props = {
    updateDetails: (details: any) => void;
};

export const DashboardEntryPanasonicProjectInfoWidget = (props: Props) => {
    const isMainViewLight = UIService.isMainViewLight();

    const [editMode, setEditMode] = useState(false);
    const [projDesc, setProjDesc] = useState("");
    const [endUserEngagement, setEndUserEngagement] = useState("");
    const [competitiveInfo, setCompetitiveInfo] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalComponent, setModalComponent] = useState<any>(null);

    useEffect(() => {
        props.updateDetails({
            projDesc,
            endUserEngagement,
            competitiveInfo,
        });
    }, [endUserEngagement, projDesc, competitiveInfo]);

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "project_description":
                setProjDesc(value);
                break;

            case "end_user_engagement":
                setEndUserEngagement(value);
                break;

            case "competitive_information":
                setCompetitiveInfo(value);
                break;
        }
    };

    const closeModal = (section: "project_description" | "end_user_engagement" | "competitive_information", value?: string) => {
        if (value) {
            switch (section) {
                case "project_description":
                    setProjDesc(value);
                    break;

                case "end_user_engagement":
                    setEndUserEngagement(value);
                    break;

                case "competitive_information":
                    setCompetitiveInfo(value);
                    break;
            }
        }

        setModalComponent(null);
        setShowModal(false);
    };

    const editModal = (section: "project_description" | "end_user_engagement" | "competitive_information") => {
        const component = (
            <DashboardEntryPanasonicInfoModal
                closeModal={closeModal}
                section={section}
                textValue={
                    section === "project_description" ? projDesc : section === "end_user_engagement" ? endUserEngagement : competitiveInfo
                }
            />
        );

        setShowModal(true);
        setModalComponent(component);
    };

    return (
        <div className={"DashboardEntryPanasonicProjectInfoWidget col-3"}>
            <div className={"d-flex justify-content-between"}>
                <OwLabel title={"project_info"} isBold={true} />

                {/*<OwLabel*/}
                {/*    title={editMode ? "save" : "edit"}*/}
                {/*    fn={() => {*/}
                {/*        toggleEditMode();*/}
                {/*    }}*/}
                {/*/>*/}
            </div>
            <div className={"card d-flex font-weight-bold card-header flex-grow h-100 " + (!isMainViewLight ? "text-white bg-dark" : "")}>
                <table className={"table " + (isMainViewLight ? "" : "table-dark")}>
                    <tbody>
                        <SectionRow>
                            <th>
                                <div className={"d-flex justify-content-between"}>
                                    <div>
                                        <OwLabel title={"project_description"} isBold={true} />
                                        <i
                                            className={"ms-2 fad fa-pencil text-primary pointer"}
                                            onClick={() => {
                                                editModal("project_description");
                                            }}
                                        />
                                    </div>
                                    {/*<div className={"d-flex text-end text-primary"}>*/}
                                    {/*    { projDesc.length ? <OwLabel className={"pointer"} title={"view"}/> : null}*/}
                                    {/*</div>*/}
                                </div>
                            </th>
                        </SectionRow>
                        <tr>
                            <td>
                                {editMode ? (
                                    <OwFnInput fn={handleChange} name={"project_description"} value={projDesc} />
                                ) : (
                                    <TextDisplay>{projDesc}</TextDisplay>
                                )}
                            </td>
                        </tr>
                        <SectionRow>
                            <th className={""}>
                                <OwLabel title={"end_user_engagement"} isBold={true} />
                                <i
                                    className={"ms-2 fad fa-pencil text-primary pointer"}
                                    onClick={() => {
                                        editModal("end_user_engagement");
                                    }}
                                />
                            </th>
                        </SectionRow>
                        <tr>
                            <td>
                                {editMode ? (
                                    <OwFnInput fn={handleChange} name={"end_user_engagement"} value={endUserEngagement} />
                                ) : (
                                    endUserEngagement
                                )}
                            </td>
                        </tr>
                        <SectionRow>
                            <th className={""}>
                                <OwLabel title={"competitive_information"} isBold={true} />
                                <i
                                    className={"ms-2 fad fa-pencil text-primary pointer"}
                                    onClick={() => {
                                        editModal("competitive_information");
                                    }}
                                />
                            </th>
                        </SectionRow>
                        <tr>
                            <td>
                                {editMode ? (
                                    <OwFnInput fn={handleChange} name={"competitive_information"} value={competitiveInfo} />
                                ) : (
                                    competitiveInfo
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <ReactModal
                isOpen={showModal}
                contentLabel=""
                className={"modalClass"}
                overlayClassName={"overlayClass"}
                style={{
                    content: {
                        width: "500px",
                        height: "320px",
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                    },
                }}>
                {modalComponent}
            </ReactModal>
        </div>
    );
};

const SectionRow = styled.tr`
    border: 0 !important;
    border-color: transparent !important;
`;

const TextDisplay = styled.div`
    max-height: 48px;
    overflow-y: scroll;
`;
